export function moniker(str: string): string {
  // squash punctuation and domains
  str = str.replace(/'/g, "");
  str = str.replace(/\.(ai|com|io)\b/i, "$1");

  // convert to words
  const sentence = str.replace(/[^A-Za-z0-9]+/g, " ").trim();
  const words = sentence.split(" ", 2);

  let two: string;
  if (words.length < 2) {
    // edge case, just use the str
    two = str.replace(/\s/g, "").substring(0, 2);
  } else {
    two = `${words[0].charAt(0)}${words[1].charAt(0)}`;
  }
  return two.toUpperCase();
}
